import { render, staticRenderFns } from "./contacts.vue?vue&type=template&id=936cdb62&scoped=true"
import script from "./contacts.vue?vue&type=script&lang=js"
export * from "./contacts.vue?vue&type=script&lang=js"
import style0 from "./contacts.vue?vue&type=style&index=0&id=936cdb62&prod&lang=css"
import style1 from "./contacts.vue?vue&type=style&index=1&id=936cdb62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936cdb62",
  null
  
)

export default component.exports